import { useState, useEffect, Fragment } from "react";
import supabase from '../supabaseClient';
import { exportarExcel, nombreArchivoExcel } from '../services/export-excel';

const EstadoBadge = ({ cargado }) => (
  <span className={`text-xs font-bold px-2 py-1 rounded-full ${cargado ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}`}>
    {cargado ? "Cargado" : "Pendiente"}
  </span>
);

const PreparadoBadge = ({ preparado }) => (
  <span className={`text-xs font-bold px-2 py-1 rounded-full ${preparado ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-600"}`}>
    {preparado ? "Preparado" : "Pendiente"}
  </span>
);

const TrazabilidadBadge = ({ trazabilidad_enviada }) => (
  <span className={`text-xs font-bold px-2 py-1 rounded-full ${trazabilidad_enviada ? "bg-orange-100 text-orange-700" : "bg-gray-100 text-gray-600"}`}>
    {trazabilidad_enviada ? "Enviada" : "Pendiente"}
  </span>
);

const ConfirmModal = ({ titulo, mensaje, onCancel, onConfirm }) => (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6 text-center space-y-3">
      <p className="text-4xl">🗑️</p>
      <h3 className="font-bold text-gray-800 text-lg">{titulo}</h3>
      <p className="text-gray-500 text-sm">{mensaje}</p>
      <div className="flex gap-3 pt-2">
        <button onClick={onCancel} className="flex-1 bg-gray-100 text-gray-700 font-bold py-2 rounded-lg hover:bg-gray-200">Cancelar</button>
        <button onClick={onConfirm} className="flex-1 bg-red-500 text-white font-bold py-2 rounded-lg hover:bg-red-600">Sí, eliminar</button>
      </div>
    </div>
  </div>
);

const PedidoModal = ({ pedido, setPedido, onGuardar, onCancel }) => {
  const actualizarLinea = (idx, campo, valor) => setPedido(p => ({ ...p, lineas: p.lineas.map((l, i) => i === idx ? { ...l, [campo]: valor } : l) }));
  const añadirLinea = () => setPedido(p => ({ ...p, lineas: [...p.lineas, initLinea()] }));
  const eliminarLinea = (idx) => setPedido(p => ({ ...p, lineas: p.lineas.filter((_, i) => i !== idx) }));
  const lineasValidas = pedido.lineas.length > 0 && pedido.lineas.every(l => l.referencia.trim());

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg p-6 space-y-4 max-h-[90vh] overflow-y-auto">
        <h3 className="font-bold text-gray-800 text-lg">{pedido.id ? "✏️ Editar pedido" : "➕ Nuevo pedido"}</h3>
        <div className="space-y-3">
          <input placeholder="Nº Pedido *" value={pedido.numero_pedido} onChange={e => setPedido(p => ({ ...p, numero_pedido: e.target.value }))} className="w-full border border-gray-200 rounded-xl px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300" />
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase">Fecha de carga</label>
            <input type="date" value={pedido.fecha_carga} onChange={e => setPedido(p => ({ ...p, fecha_carga: e.target.value }))} className="w-full border border-gray-200 rounded-xl px-4 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-300" />
          </div>
          <label className="flex items-center gap-2 text-sm text-gray-700">
            <input type="checkbox" checked={pedido.preparado} onChange={e => setPedido(p => ({ ...p, preparado: e.target.checked }))} className="w-4 h-4" />
            Marcar como preparado
          </label>
          <label className="flex items-center gap-2 text-sm text-gray-700">
            <input type="checkbox" checked={pedido.cargado} onChange={e => setPedido(p => ({ ...p, cargado: e.target.checked }))} className="w-4 h-4" />
            Marcar como cargado
          </label>
          <label className="flex items-center gap-2 text-sm text-gray-700">
            <input type="checkbox" checked={pedido.trazabilidad_enviada} onChange={e => setPedido(p => ({ ...p, trazabilidad_enviada: e.target.checked }))} className="w-4 h-4" />
            Trazabilidad enviada
          </label>
        </div>

        <div className="border-t pt-3 space-y-2">
          <p className="text-xs font-bold text-gray-600 uppercase">Líneas del pedido</p>
          {pedido.lineas.map((l, idx) => (
            <div key={idx} className="flex gap-2 items-start bg-gray-50 rounded-xl p-2">
              <div className="flex-1 space-y-2">
                <input placeholder="Referencia *" value={l.referencia} onChange={e => actualizarLinea(idx, 'referencia', e.target.value)} className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300" />
                <div className="grid grid-cols-2 gap-2">
                  <input type="number" placeholder="Palets" value={l.palets} onChange={e => actualizarLinea(idx, 'palets', e.target.value)} className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300" />
                  <input type="number" placeholder="Unidades" value={l.unidades} onChange={e => actualizarLinea(idx, 'unidades', e.target.value)} className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300" />
                </div>
              </div>
              <button onClick={() => eliminarLinea(idx)} disabled={pedido.lineas.length <= 1} className="text-red-500 hover:text-red-700 disabled:opacity-30 disabled:cursor-not-allowed p-1" title="Eliminar línea">🗑️</button>
            </div>
          ))}
          <button onClick={añadirLinea} className="text-blue-600 text-xs font-semibold hover:text-blue-800">+ Añadir línea</button>
        </div>

        <div className="flex gap-3 pt-2">
          <button onClick={onGuardar} disabled={!pedido.numero_pedido.trim() || !lineasValidas} className="flex-1 bg-blue-600 text-white font-semibold py-2 rounded-xl hover:bg-blue-700 disabled:opacity-40 transition-all text-sm">Guardar</button>
          <button onClick={onCancel} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2 rounded-xl hover:bg-gray-200 transition-all text-sm">Cancelar</button>
        </div>
      </div>
    </div>
  );
};

const EntradaModal = ({ entrada, setEntrada, onGuardar, onCancel }) => (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 space-y-4">
      <h3 className="font-bold text-gray-800 text-lg">{entrada.id ? "✏️ Editar entrada" : "➕ Nueva entrada"}</h3>
      <div className="space-y-3">
        <input placeholder="Nº Albarán *" value={entrada.numero_albaran} onChange={e => setEntrada(x => ({ ...x, numero_albaran: e.target.value }))} className="w-full border border-gray-200 rounded-xl px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300" />
        <div>
          <label className="text-xs font-semibold text-gray-500 uppercase">Fecha *</label>
          <input type="date" value={entrada.fecha} onChange={e => setEntrada(x => ({ ...x, fecha: e.target.value }))} className="w-full border border-gray-200 rounded-xl px-4 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-300" />
        </div>
        <textarea placeholder="Referencias" rows={3} value={entrada.referencias} onChange={e => setEntrada(x => ({ ...x, referencias: e.target.value }))} className="w-full border border-gray-200 rounded-xl px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300" />
      </div>
      <div className="flex gap-3 pt-2">
        <button onClick={onGuardar} disabled={!entrada.numero_albaran.trim() || !entrada.fecha} className="flex-1 bg-blue-600 text-white font-semibold py-2 rounded-xl hover:bg-blue-700 disabled:opacity-40 transition-all text-sm">Guardar</button>
        <button onClick={onCancel} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2 rounded-xl hover:bg-gray-200 transition-all text-sm">Cancelar</button>
      </div>
    </div>
  </div>
);

const initLinea = () => ({ referencia: "", palets: "", unidades: "" });
const initPedido = () => ({ numero_pedido: "", fecha_carga: "", cargado: false, preparado: false, trazabilidad_enviada: false, lineas: [initLinea()] });
const initEntrada = () => ({ numero_albaran: "", fecha: "", referencias: "" });

// ── ADMIN VOLDIS: INTERNACIONAL (Pedidos + Entradas de camión) ──
export const VoldisInternacionalSection = () => {
  const [subTab, setSubTab] = useState("pedidos");

  const [pedidos, setPedidos] = useState([]);
  const [loadingPedidos, setLoadingPedidos] = useState(true);
  const [modalPedido, setModalPedido] = useState(null);
  const [confirmEliminarPedido, setConfirmEliminarPedido] = useState(null);
  const [expandedPedidoId, setExpandedPedidoId] = useState(null);

  const [busquedaNumero, setBusquedaNumero] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("todos");
  const [filtroPreparado, setFiltroPreparado] = useState("todos");
  const [filtroTrazabilidad, setFiltroTrazabilidad] = useState("todos");
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");

  const [entradas, setEntradas] = useState([]);
  const [loadingEntradas, setLoadingEntradas] = useState(true);
  const [modalEntrada, setModalEntrada] = useState(null);
  const [confirmEliminarEntrada, setConfirmEliminarEntrada] = useState(null);

  const cargarPedidos = async () => {
    setLoadingPedidos(true);
    const { data } = await supabase.from('voldis_pedidos').select('*, voldis_pedidos_lineas(*)').order('created_at', { ascending: false });
    setPedidos(data || []);
    setLoadingPedidos(false);
  };

  const cargarEntradas = async () => {
    setLoadingEntradas(true);
    const { data } = await supabase.from('voldis_entradas_camion').select('*').order('created_at', { ascending: false });
    setEntradas(data || []);
    setLoadingEntradas(false);
  };

  useEffect(() => { cargarPedidos(); cargarEntradas(); }, []);

  const guardarPedido = async () => {
    const header = {
      numero_pedido: modalPedido.numero_pedido.trim(),
      fecha_carga: modalPedido.fecha_carga || null,
      cargado: !!modalPedido.cargado,
      preparado: !!modalPedido.preparado,
      trazabilidad_enviada: !!modalPedido.trazabilidad_enviada,
    };
    const lineas = modalPedido.lineas.map(l => ({
      referencia: l.referencia.trim(),
      palets: l.palets === "" ? null : Number(l.palets),
      unidades: l.unidades === "" ? null : Number(l.unidades),
    }));

    if (modalPedido.id) {
      await supabase.from('voldis_pedidos').update(header).eq('id', modalPedido.id);
      await supabase.from('voldis_pedidos_lineas').delete().eq('pedido_id', modalPedido.id);
      await supabase.from('voldis_pedidos_lineas').insert(lineas.map(l => ({ ...l, pedido_id: modalPedido.id })));
    } else {
      const { data } = await supabase.from('voldis_pedidos').insert(header).select().single();
      if (data) {
        await supabase.from('voldis_pedidos_lineas').insert(lineas.map(l => ({ ...l, pedido_id: data.id })));
      }
    }
    setModalPedido(null);
    cargarPedidos();
  };

  const eliminarPedido = async () => {
    const { data } = await supabase.from('voldis_pedidos').delete().eq('id', confirmEliminarPedido.id).select();
    setConfirmEliminarPedido(null);
    if (data && data.length > 0) setPedidos(p => p.filter(x => x.id !== confirmEliminarPedido.id));
  };

  const guardarEntrada = async () => {
    const payload = {
      numero_albaran: modalEntrada.numero_albaran.trim(),
      fecha: modalEntrada.fecha,
      referencias: modalEntrada.referencias.trim(),
    };
    if (modalEntrada.id) {
      await supabase.from('voldis_entradas_camion').update(payload).eq('id', modalEntrada.id);
    } else {
      await supabase.from('voldis_entradas_camion').insert(payload);
    }
    setModalEntrada(null);
    cargarEntradas();
  };

  const eliminarEntrada = async () => {
    const { data } = await supabase.from('voldis_entradas_camion').delete().eq('id', confirmEliminarEntrada.id).select();
    setConfirmEliminarEntrada(null);
    if (data && data.length > 0) setEntradas(e => e.filter(x => x.id !== confirmEliminarEntrada.id));
  };

  const pedidosFiltrados = pedidos.filter(p => {
    if (busquedaNumero.trim() && !p.numero_pedido?.toLowerCase().includes(busquedaNumero.trim().toLowerCase())) return false;
    if (filtroEstado === "pendiente" && p.cargado) return false;
    if (filtroEstado === "cargado" && !p.cargado) return false;
    if (filtroPreparado === "preparado" && !p.preparado) return false;
    if (filtroPreparado === "sin_preparar" && p.preparado) return false;
    if (filtroTrazabilidad === "enviada" && !p.trazabilidad_enviada) return false;
    if (filtroTrazabilidad === "pendiente" && p.trazabilidad_enviada) return false;
    if (fechaDesde && (!p.fecha_carga || p.fecha_carga < fechaDesde)) return false;
    if (fechaHasta && (!p.fecha_carga || p.fecha_carga > fechaHasta)) return false;
    return true;
  });

  const limpiarFiltros = () => { setBusquedaNumero(""); setFiltroEstado("todos"); setFiltroPreparado("todos"); setFiltroTrazabilidad("todos"); setFechaDesde(""); setFechaHasta(""); };

  const exportarPedidosExcel = () => {
    const filas = [];
    pedidosFiltrados.forEach(p => {
      const lineas = p.voldis_pedidos_lineas && p.voldis_pedidos_lineas.length > 0 ? p.voldis_pedidos_lineas : [{ referencia: "", palets: "", unidades: "" }];
      lineas.forEach(l => {
        filas.push({
          "Nº Pedido": p.numero_pedido,
          "Referencia": l.referencia || "",
          "Palets": l.palets ?? "",
          "Unidades": l.unidades ?? "",
          "Fecha Carga": p.fecha_carga || "",
          "Estado": p.cargado ? "Cargado" : "Pendiente",
          "Preparado": p.preparado ? "Sí" : "No",
        });
      });
    });
    exportarExcel(nombreArchivoExcel("pedidos_internacional", "Voldis"), [{ nombre: "Pedidos", filas }]);
  };

  const exportarEntradasExcel = () => {
    const filas = entradas.map(e => ({
      "Nº Albarán": e.numero_albaran,
      "Fecha": e.fecha || "",
      "Referencias": e.referencias || "",
    }));
    exportarExcel(nombreArchivoExcel("entradas_camion_internacional", "Voldis"), [{ nombre: "Entradas", filas }]);
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <button onClick={() => setSubTab("pedidos")} className={`px-3 py-2 text-xs font-semibold rounded-lg transition-all ${subTab === "pedidos" ? "bg-green-600 text-white shadow" : "bg-white text-gray-600 hover:bg-green-50 border border-gray-200"}`}>Pedidos</button>
        <button onClick={() => setSubTab("entradas")} className={`px-3 py-2 text-xs font-semibold rounded-lg transition-all ${subTab === "entradas" ? "bg-green-600 text-white shadow" : "bg-white text-gray-600 hover:bg-green-50 border border-gray-200"}`}>Entradas de camión</button>
      </div>

      {subTab === "pedidos" && (
        <div className="space-y-3">
          <div className="flex items-center justify-between flex-wrap gap-2">
            <h2 className="font-bold text-gray-800">🌍 Pedidos Internacional</h2>
            <div className="flex gap-2">
              <button onClick={exportarPedidosExcel} disabled={pedidosFiltrados.length === 0} className="bg-gray-100 text-gray-700 text-sm font-medium px-4 py-2 rounded-xl hover:bg-gray-200 disabled:opacity-40 transition-all">📥 Exportar Excel</button>
              <button onClick={() => setModalPedido(initPedido())} className="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-xl hover:bg-blue-700 transition-all">+ Nuevo pedido</button>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow p-3 flex flex-wrap gap-3 items-end">
            <div className="flex-1 min-w-[160px]">
              <label className="text-xs font-semibold text-gray-500 uppercase">Buscar</label>
              <input placeholder="Buscar nº pedido..." value={busquedaNumero} onChange={e => setBusquedaNumero(e.target.value)} className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-300" />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-500 uppercase">Estado</label>
              <div className="flex gap-1 mt-1">
                {[["todos", "Todos"], ["pendiente", "Pendiente"], ["cargado", "Cargado"]].map(([val, lab]) => (
                  <button key={val} onClick={() => setFiltroEstado(val)} className={`px-3 py-2 text-xs font-semibold rounded-lg transition-all ${filtroEstado === val ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}>{lab}</button>
                ))}
              </div>
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-500 uppercase">Preparado</label>
              <div className="flex gap-1 mt-1">
                {[["todos", "Todos"], ["preparado", "Preparado"], ["sin_preparar", "Sin preparar"]].map(([val, lab]) => (
                  <button key={val} onClick={() => setFiltroPreparado(val)} className={`px-3 py-2 text-xs font-semibold rounded-lg transition-all ${filtroPreparado === val ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}>{lab}</button>
                ))}
              </div>
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-500 uppercase">Trazabilidad</label>
              <div className="flex gap-1 mt-1">
                {[["todos", "Todos"], ["enviada", "Enviada"], ["pendiente", "Pendiente"]].map(([val, lab]) => (
                  <button key={val} onClick={() => setFiltroTrazabilidad(val)} className={`px-3 py-2 text-xs font-semibold rounded-lg transition-all ${filtroTrazabilidad === val ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}>{lab}</button>
                ))}
              </div>
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-500 uppercase">Desde</label>
              <input type="date" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} className="border border-gray-200 rounded-xl px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-300" />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-500 uppercase">Hasta</label>
              <input type="date" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} className="border border-gray-200 rounded-xl px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-300" />
            </div>
            <button onClick={limpiarFiltros} className="bg-gray-100 text-gray-700 text-sm font-medium px-4 py-2 rounded-xl hover:bg-gray-200 transition-all">Limpiar filtros</button>
          </div>

          {loadingPedidos ? (
            <p className="text-sm text-gray-500">Cargando...</p>
          ) : (
            <div className="bg-white rounded-xl shadow overflow-x-auto">
              <table className="w-full text-sm min-w-max">
                <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
                  <tr>
                    <th className="px-4 py-3 text-left">Nº Pedido</th>
                    <th className="px-4 py-3 text-left">Líneas</th>
                    <th className="px-4 py-3 text-left">Fecha Carga</th>
                    <th className="px-4 py-3 text-left">Estado</th>
                    <th className="px-4 py-3 text-left">Preparado</th>
                    <th className="px-4 py-3 text-left">Trazabilidad</th>
                    <th className="px-4 py-3 text-left">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {pedidosFiltrados.map(p => {
                    const lineas = p.voldis_pedidos_lineas || [];
                    const isExpanded = expandedPedidoId === p.id;
                    return (
                      <Fragment key={p.id}>
                        <tr className="border-t hover:bg-gray-50 cursor-pointer" onClick={() => setExpandedPedidoId(isExpanded ? null : p.id)}>
                          <td className="px-4 py-2 font-semibold">{p.numero_pedido}</td>
                          <td className="px-4 py-2">{lineas.length}</td>
                          <td className="px-4 py-2">{p.fecha_carga || "—"}</td>
                          <td className="px-4 py-2"><EstadoBadge cargado={p.cargado} /></td>
                          <td className="px-4 py-2"><PreparadoBadge preparado={p.preparado} /></td>
                          <td className="px-4 py-2"><TrazabilidadBadge trazabilidad_enviada={p.trazabilidad_enviada} /></td>
                          <td className="px-4 py-2 flex gap-2" onClick={e => e.stopPropagation()}>
                            <button onClick={() => setModalPedido({
                              id: p.id,
                              numero_pedido: p.numero_pedido,
                              fecha_carga: p.fecha_carga || "",
                              cargado: p.cargado,
                              preparado: p.preparado,
                              trazabilidad_enviada: p.trazabilidad_enviada,
                              lineas: lineas.length > 0 ? lineas.map(l => ({ referencia: l.referencia, palets: l.palets ?? "", unidades: l.unidades ?? "" })) : [initLinea()],
                            })} className="text-blue-600 hover:text-blue-800" title="Editar">✏️</button>
                            <button onClick={() => setConfirmEliminarPedido(p)} className="text-red-600 hover:text-red-800" title="Eliminar">🗑️</button>
                          </td>
                        </tr>
                        {isExpanded && (
                          <tr className="border-t bg-gray-50">
                            <td colSpan={7} className="px-4 py-3">
                              <table className="w-full text-xs">
                                <thead className="text-gray-500 uppercase">
                                  <tr>
                                    <th className="text-left py-1">Referencia</th>
                                    <th className="text-left py-1">Palets</th>
                                    <th className="text-left py-1">Unidades</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {lineas.map(l => (
                                    <tr key={l.id}>
                                      <td className="py-1">{l.referencia}</td>
                                      <td className="py-1">{l.palets ?? "—"}</td>
                                      <td className="py-1">{l.unidades ?? "—"}</td>
                                    </tr>
                                  ))}
                                  {lineas.length === 0 && (
                                    <tr><td colSpan={3} className="py-2 text-gray-400">Sin líneas.</td></tr>
                                  )}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </Fragment>
                    );
                  })}
                  {pedidosFiltrados.length === 0 && (
                    <tr><td colSpan={7} className="px-4 py-6 text-center text-gray-400">{pedidos.length === 0 ? "No hay pedidos todavía." : "No se encontraron pedidos con los filtros aplicados."}</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {subTab === "entradas" && (
        <div className="space-y-3">
          <div className="flex items-center justify-between flex-wrap gap-2">
            <h2 className="font-bold text-gray-800">🚛 Entradas de Camión</h2>
            <div className="flex gap-2">
              <button onClick={exportarEntradasExcel} disabled={entradas.length === 0} className="bg-gray-100 text-gray-700 text-sm font-medium px-4 py-2 rounded-xl hover:bg-gray-200 disabled:opacity-40 transition-all">📥 Exportar Excel</button>
              <button onClick={() => setModalEntrada(initEntrada())} className="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-xl hover:bg-blue-700 transition-all">+ Nueva entrada</button>
            </div>
          </div>
          {loadingEntradas ? (
            <p className="text-sm text-gray-500">Cargando...</p>
          ) : (
            <div className="bg-white rounded-xl shadow overflow-x-auto">
              <table className="w-full text-sm min-w-max">
                <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
                  <tr>
                    <th className="px-4 py-3 text-left">Nº Albarán</th>
                    <th className="px-4 py-3 text-left">Fecha</th>
                    <th className="px-4 py-3 text-left">Referencias</th>
                    <th className="px-4 py-3 text-left">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {entradas.map(e => (
                    <tr key={e.id} className="border-t hover:bg-gray-50">
                      <td className="px-4 py-2 font-semibold">{e.numero_albaran}</td>
                      <td className="px-4 py-2">{e.fecha || "—"}</td>
                      <td className="px-4 py-2 whitespace-pre-wrap">{e.referencias || "—"}</td>
                      <td className="px-4 py-2 flex gap-2">
                        <button onClick={() => setModalEntrada({ ...e })} className="text-blue-600 hover:text-blue-800" title="Editar">✏️</button>
                        <button onClick={() => setConfirmEliminarEntrada(e)} className="text-red-600 hover:text-red-800" title="Eliminar">🗑️</button>
                      </td>
                    </tr>
                  ))}
                  {entradas.length === 0 && (
                    <tr><td colSpan={4} className="px-4 py-6 text-center text-gray-400">No hay entradas todavía.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {modalPedido && (
        <PedidoModal pedido={modalPedido} setPedido={setModalPedido} onGuardar={guardarPedido} onCancel={() => setModalPedido(null)} />
      )}
      {confirmEliminarPedido && (
        <ConfirmModal
          titulo="¿Eliminar pedido?"
          mensaje={`El pedido "${confirmEliminarPedido.numero_pedido}" se eliminará de forma permanente.`}
          onCancel={() => setConfirmEliminarPedido(null)}
          onConfirm={eliminarPedido}
        />
      )}
      {modalEntrada && (
        <EntradaModal entrada={modalEntrada} setEntrada={setModalEntrada} onGuardar={guardarEntrada} onCancel={() => setModalEntrada(null)} />
      )}
      {confirmEliminarEntrada && (
        <ConfirmModal
          titulo="¿Eliminar entrada?"
          mensaje={`El albarán "${confirmEliminarEntrada.numero_albaran}" se eliminará de forma permanente.`}
          onCancel={() => setConfirmEliminarEntrada(null)}
          onConfirm={eliminarEntrada}
        />
      )}
    </div>
  );
};
